// BMAP file format types. Spec authority: Stuart Cheshire's BoloMapFile.h
// (in references/Bolo f/More information/Sample Code/Map File Format/).
//
// Disk encoding uses terrain codes 0-9 with 10-15 being mined variants of 2-7.
// Deep sea is implicit (any square not in a run). The runtime model in
// @bolo2k/shared uses a different layout — terrain code in low bits + a
// 0x80 mine bit. Conversion is performed by the reader/writer.

import { MAP_SIZE } from '@bolo2k/shared';

export const BMAP_MAGIC = 'BMAPBOLO';
export const BMAP_VERSION = 1;

export interface BMapPillbox {
  x: number; // 0-255 map coords
  y: number;
  owner: number; // 0xFF = neutral
  armour: number; // 0-15 (0 = dead)
  speed: number; // ticks between shots, typical 50
}

export interface BMapBase {
  x: number;
  y: number;
  owner: number; // 0xFF = neutral
  armour: number; // 0-90
  shells: number; // 0-90
  mines: number; // 0-90
}

export interface BMapStart {
  x: number;
  y: number;
  // BMAP convention: 0-15 in 22.5° steps, 0=East counterclockwise.
  // The runtime/Brain.h convention is 0-255 with 0=N — convert at use site.
  dir: number;
}

export interface BMapData {
  version: number;
  pillboxes: BMapPillbox[];
  bases: BMapBase[];
  starts: BMapStart[];
  // 256x256 row-major, runtime encoding: low 4 bits = TerrainCode, 0x80 = mine.
  // Squares not present in any run are filled with Terrain.DeepSea (10).
  terrain: Uint8Array;
}

export const TERRAIN_BYTES = MAP_SIZE * MAP_SIZE;
